import styled, { css } from 'styled-components'

export const SubMenu = styled.div`
  display: flex;
  padding: 0px 48px 16px 48px;
  position: relative;
  align-items: center;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 48px;
    z-index: 1;
    pointer-events: none;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`

export const SubMenuContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  ${(props) =>
    props.isMobile &&
    css`
      overflow-x: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      scroll-behavior: smooth;
      padding: 0 28px;

      &::-webkit-scrollbar {
        display: none;
      }
    `}
`

export const SubMenuItem = styled.span<{ active: boolean }>`
  color: #757575;
  padding: 10px 16px;
  border-radius: 24px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  font-family: Roboto;
  transition: 200ms;
  white-space: nowrap;
  flex-shrink: 0;
  ${(props) =>
    props.active &&
    css`
      background-color: #e7f3fe;
      border: 1px solid #9ecffa;
      color: #213f68;
    `};
  &:hover {
    color: #005ed9;
  }
`

export const ScrollButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: 200ms;

  &:hover {
    background: #f5f5f5;
  }

  &:active {
    background: #e0e0e0;
  }

  &.left {
    left: 8px;
  }

  &.right {
    right: 8px;
  }
`
